import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0caf5c0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "black" }, null, -1))
const _hoisted_2 = ["v-if"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ViewPort = _resolveComponent("ViewPort")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("label", {
      class: _normalizeClass(["absolute left-0 top-0 z-50", [_ctx.showInputField ? '' : ' opacity-0']]),
      "v-if": _ctx.visitercode == null,
      for: ""
    }, [
      _withDirectives(_createElementVNode("input", {
        ref: "qrInput",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
        class: _normalizeClass(["z-50 relative", [_ctx.showInputField ? '' : ' opacity-0']]),
        type: "text",
        autofocus: ""
      }, null, 2), [
        [_vModelText, _ctx.inputValue]
      ])
    ], 10, _hoisted_2),
    _createVNode(_component_ViewPort, {
      stories: _ctx.stories,
      "story-selected": _ctx.selectedStory,
      "story-service": _ctx.storyService,
      "state-service": _ctx.stateService,
      "current-state": _ctx.currentState,
      "show-pause-overview": _ctx.showPauseOverview,
      onResetSelectedStory: _ctx.resetSelectedStory
    }, null, 8, ["stories", "story-selected", "story-service", "state-service", "current-state", "show-pause-overview", "onResetSelectedStory"])
  ]))
}